import type { FaireProductEntity } from "../../entity_types/product";

export const matcha_13: FaireProductEntity = {
  token: "matcha-13",
  type: "product",
  name: "Hone Lavender Matcha SuperLatte",
  brandName: "Clevr",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/a41f041964c7bc052bf934c3e834df6c0b81c516b60975a3d67e4bdc5855b38d.png",
  priceDollars: 19,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/a41f041964c7bc052bf934c3e834df6c0b81c516b60975a3d67e4bdc5855b38d.png",
  weight: 0.4,
  dimensions: {
    width: 4,
    height: 6,
    depth: 2,
  },
  description: "Hone lavender matcha superlatte blend",
  categoryTokens: ["cat_food-beverages"],
  tags: ["matcha", "tea", "latte", "lavender", "wellness", "premium"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
